import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { LocalStorageService } from './localstorage.service';
import { AuditLogService } from './audit-log.service';
import { DashboardInformationDto } from '../modals/dashboard/dashboardInformationDto';
import { ScreenDto } from '../modals/dashboard/screenDto';
import { BaseService } from './incomeTaxBase.service';
import { SearchScreenDependencyDto } from '../commonDto/navbarLinks/SearchScreenDependencyDto';
import { HelperPopUpDto } from '../commonDto/navbarLinks/HelperPopUpDto';

@Injectable({
  providedIn: 'root'
})
export class NavbarContainerService {
  // baseUrl: string = environment.apiUrlV1
  baseUrl: string = environment.apiUrlV1

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private auditLogService: AuditLogService,
    private baseService: BaseService
  ) { }

  GetDashboardInformation(params?: HttpParams): Observable<DashboardInformationDto> {
    return this.baseService.getApi<DashboardInformationDto>({ methodPath: 'Common/GetDashboardInformation' }, { params: params })
  }

  GetAllScreen(params?: HttpParams): Observable<ScreenDto[]> {
    return this.baseService.getApi<ScreenDto[]>({ methodPath: 'Common/GetAllScreen' }, { params: params })
  }

  UpdateAcademicBatchOrganization(body: string, headers?: HttpHeaders) {
    return this.baseService.postApi('Common/UpdateAcademicBatchOrganization', body, headers)
  }

  GetSearchScreenDependency(params?: HttpParams): Observable<SearchScreenDependencyDto> {
    return this.baseService.getApi<SearchScreenDependencyDto>({ methodPath:  'Common/GetSearchScreenDependency' }, { params: params })
  }

  GetHelperPopUp(params?: HttpParams): Observable<HelperPopUpDto> {
    return this.baseService.getApi<HelperPopUpDto>({ methodPath:  'Common/GetHelperPopUp' }, { params: params })
  }

  Logoff(body?: string, headers?: HttpHeaders): Observable<boolean> {
    return this.baseService.postApi('Common/Logoff', body, headers)
  }
}
